export default __webpack_public_path__ + "static/media/logo-nasa.c5d11f88.svg";